<template>
  <referral-page-error-container v-if="referralDetailsErrorState"></referral-page-error-container>
  <div v-else>
    <div v-if="featureSwitchesState.REFERRAL_DETAILS" class="container max-width-container">
      <section class="section">
        <div class="columns is-multiline is-centered">
          <div class="column referral is-paddingless">
            <back-button @click="goToDashboard"></back-button>

            <div class="columns">
              <div class="column is-4-desktop is-half-tablet content-column">
                <div v-if="referralsLoadingState" class="loader"></div>
                <h2 v-else class="heading-2">
                  <span>{{ referralDetails.full_name }}</span>
                </h2>

                <h4 class="heading-4 paragraph-dark-gray">
                  {{ referralDetails.job_title }}
                </h4>

                <tokens-overview-container></tokens-overview-container>
              </div>

              <div class="column is-8-desktop content-column">
                <referral-status-container></referral-status-container>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import BackButton from 'top20common/components/buttons/BackButton';
import {mapGetters} from 'vuex';

import ReferralPageErrorContainer from './ReferralPageErrorContainer';
import ReferralStatusContainer from './ReferralStatusContainer';
import TokensOverviewContainer from './tokens-overview/TokensOverviewContainer';

export default {
  created() {
    this.$store.dispatch('fetchTokensAction');
    this.$store.dispatch('getReferralDetailsAction', this.$route.params.slug).then(referral => {
      if (referral.need_review && this.featureSwitchesState.REFERRAL_DETAILS) {
        this.$store.dispatch('reviewReferralAction', referral.slug);
      }
    });
  },
  data() {
    return {
      showBackButton: true
    };
  },
  computed: {
    ...mapGetters([
      'referralDetailsBySlugState',
      'referralsLoadingState',
      'featureSwitchesState',
      'referralDetailsErrorState'
    ]),
    referralSlug() {
      return this.$route.params.slug;
    },
    referralDetails() {
      let referralDetails = this.referralDetailsBySlugState[this.referralSlug];
      return referralDetails || {};
    }
  },
  methods: {
    goToDashboard() {
      this.$router.push({name: 'dashboard'});
    }
  },
  components: {
    ReferralPageErrorContainer,
    ReferralStatusContainer,
    TokensOverviewContainer,
    BackButton
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.referral-page {
  .referral {
    width: 100%;
  }

  .btn-back {
    width: auto;

    svg {
      position: relative;
      top: -1px;
    }

    span {
      padding-left: 5px;
    }
  }
}

@media screen and (min-width: $tablet) {
  .referral {
    .heading-4 {
      padding-bottom: 50px;
    }

    .btn-back {
      margin-left: 15px;
    }
  }
}

@media screen and (max-width: $tablet) {
  .referral-page {
    .section {
      padding: 10px 1.5rem 3rem;

      .column {
        padding: 20px 0;
      }

      .referral {
        .heading-4 {
          padding-bottom: 25px;
        }
      }
    }
  }
}
</style>
